import React from 'react'
import { Spinner } from "@blueprintjs/core";


const Classic = () => {
    return (
        <div style={{ marginTop: "40px" }}>
            <Spinner size={50} />
        </div>
    )
}

export default Classic
